import { Component, createRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import NotificationsSystem, { atalhoTheme, dismissNotification, setUpNotifications } from "reapop";
import { withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import moment from "moment";
import "moment/locale/fr";
import { withRouter } from "react-router-dom";
import LocationListener from "../components/LocationListener";
import { loadActiveUser } from "../redux/users/usersActions";
import HeaderContainer from "./Layout/HeaderContainer";
import BodyContainer from "./Layout/BodyContainer";
import Loader from "../components/Basics/Loader";
import Background from "../images/background_cesbron.png";
import { hideMenu, scrollYChange } from "../redux/contextInfos/contextInfosActions";
import BackToTop from "../components/Basics/BackToTop";
import { arraysAreSame } from "../lib/array_helper";
import Debugger from "../components/Debug/Debugger";
import { deepCompare, mobileAndTabletCheck } from "../utils";
import performanceModeManager from "../performanceModeManager";
import BrowserCompatibility from "../components/Basics/BrowserCompatibility";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../utils.css";
import { MYOPEN } from "../constants";
import { loadCurrentNews } from "../redux/news/newsActions";
import { authorizedAppsFetchData } from "../redux/authorizedApps/authorizedAppsActions";
import { initPeriodicCheckOfTTE } from "../redux/imputations/imputationsActions";
import { loadLoggedEmployee } from "../redux/employees/loggedEmployeeActions";
import { actualizeNumberEPIToCheck } from "../redux/epi/epiActions";
import { actualizeNbWaitingInterviews } from "../redux/humanResources/humanResourcesActions";

// import { connect } from 'react-redux'>
export const theme = createTheme({
    typography: {
        useNextVariants: true,
    },
    shadows: [
        "none",
        "0px 15px 60px rgba(0, 0, 0, 0.25)",
        "0px 35px 60px rgba(0, 0, 0, 0.25)",
        "20px 55px 60px rgba(0, 0, 0, 0.25)",
        "10px 15px 60px rgba(0, 0, 0, 0.25)",
        ...Array(20).fill("none"),
    ],
    palette: {
        primary: {
            light: "#1089FF",
            main: "#1057C8",
            dark: "#001A70",
            contrastText: "#fff",
        },
        secondary: {
            light: "#FFB210",
            main: "#FE5716",
            dark: "#FE5716",
            contrastText: "#fff",
        },
        tertiary: {
            light: "#C0E410",
            main: "#88D910",
            dark: "#4F9E30",
            contrastText: "#fff",
        },
        neutral: {
            light: "#E0E0E0",
            main: "#666666",
            dark: "#333333",
            contrastText: "#fff",
        },
    },
});

const style = {
    backgroundImage: "url(" + Background + ")",
};

class App extends Component {
    constructor(props) {
        super(props);

        moment.locale("fr");
        this.state = props.getDefaultSyncState();
        this.state.scrollPosition = 0;
        this.state.enableDebugger = mobileAndTabletCheck(); //Enable only on mobile device else we lose informations on console logs

        this.container = createRef();

        if (
            this.props.activeUser &&
            this.props.activeUser.application === MYOPEN &&
            this.props.contextualProps.loadInterventionModel
        )
            this.props.loadInterventionModel();

        performanceModeManager();
        this.props.loadCurrentNews();
    }

    componentDidUpdate(prevProps) {
        if (!deepCompare(prevProps.activeUser, this.props.activeUser) && this.props.activeUser) {
            this.props.fetchData(this.props.activeUser);
            this.props.actualizeNbWaitingInterviews(this.props.activeUser);
        }
    }

    componentDidMount() {
        this.props.loadActiveUser((user) => {
            if (user) {
                this.launchSynchronisations();

                if (user.application === MYOPEN)
                    this.props.loadLoggedEmployee(
                        user.id,
                        user.emp_id,
                        () => {
                            this.launchPeriodicCheckOfTTE();
                        },
                        true
                    );
                this.props.actualizeNumberEPIToCheck(user);
                this.props.actualizeNbWaitingInterviews(user);
            }
        });
    }

    launchSynchronisations() {
        this.props.initSynchronisations(
            this.state,
            getStateAccessor(this.props),
            this.props.history,
            this.props.interventionsFilters,
            this.props.siteMonitoringsFilters
        );
    }

    launchPeriodicCheckOfTTE() {
        this.props.initPeriodicCheckOfTTE(this.props.loggedEmployee.loggedEmployee, this.props.activeUser);
    }

    onScroll() {
        this.displayOrHideStickyMenu();
    }

    displayOrHideStickyMenu() {
        if (this.container.current.scrollTop > this.state.scrollPosition) this.props.hideMenu(true);
        else this.props.hideMenu(false);

        this.setState({ scrollPosition: this.container.current.scrollTop });
        this.props.scrollYChange(this.container.current.scrollTop);
    }

    backToTop() {
        this.container.current.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    shouldComponentUpdate(nextProps, prevState) {
        return (
            !arraysAreSame(this.props.notifications, nextProps.notifications) ||
            this.props.activeUser !== nextProps.activeUser ||
            this.props.context.debugging !== nextProps.context.debugging ||
            this.state.enableDebugger !== prevState.enableDebugger
        );
    }

    render() {
        const { notifications } = this.props;
        setUpNotifications({
            defaultProps: {
                position: "top-right",
                dismissible: true,
            },
        });

        return (
            <ThemeProvider theme={theme}>
                <div
                    style={style}
                    id="container"
                    onScroll={this.onScroll.bind(this)}
                    onTouchMove={this.onScroll.bind(this)}
                    ref={this.container}
                    className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding my-open-container"
                >
                    <LocationListener>
                        <HeaderContainer
                            appBar={this.props.appBar}
                            publicRoutes={this.props.publicRoutes}
                            privateRoutes={this.props.privateRoutes}
                        />
                        <div className="body-container">
                            <BodyContainer
                                container={this.container}
                                testingUserEmail={this.props.testingUserEmail}
                                publicRoutes={this.props.publicRoutes}
                                privateRoutes={this.props.privateRoutes}
                            />
                        </div>
                    </LocationListener>
                    <NotificationsSystem
                        notifications={notifications}
                        dismissNotification={(id) => this.props.dismissNotification(id)}
                        theme={atalhoTheme}
                    />
                    <BackToTop backToTop={this.backToTop.bind(this)} />
                    {this.state.enableDebugger && this.props.context.debugging && <Debugger />}
                </div>
                <Loader />
                <BrowserCompatibility />
            </ThemeProvider>
        );
    }
}

App.propTypes = {
    notifications: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        notifications: state.notifications,
        activeUser: state.activeUser,
        context: state.context,
        interventionsFilters: state.interventions,
        siteMonitoringsFilters: state.siteMonitorings.siteMonitoringsFilters,
        loggedEmployee: state.loggedEmployee,
        formsFilters: state.forms.formsFilters,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadActiveUser: (onSuccess) => dispatch(loadActiveUser(onSuccess)),
        hideMenu: (value) => dispatch(hideMenu(value)),
        scrollYChange: (scrollY) => dispatch(scrollYChange(scrollY)),
        loadInterventionModel: () => dispatch(ownProps.contextualProps.loadInterventionModel()),
        loadCurrentNews: () => dispatch(loadCurrentNews()),
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
        initPeriodicCheckOfTTE: (loggedEmployee, user) => dispatch(initPeriodicCheckOfTTE(loggedEmployee, user)),
        loadLoggedEmployee: (userId, empId, onSuccess, discreet) =>
            dispatch(loadLoggedEmployee(userId, empId, onSuccess, discreet)),
        initSynchronisations: (state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) =>
            dispatch(
                ownProps.initSynchronisations(
                    state,
                    stateAccessor,
                    history,
                    interventionsFilters,
                    siteMonitoringsFilters
                )
            ),
        dismissNotification: (id) => dispatch(dismissNotification(id)),
        actualizeNumberEPIToCheck: (activeUser) => dispatch(actualizeNumberEPIToCheck(activeUser)),
        actualizeNbWaitingInterviews: (activeUser) => dispatch(actualizeNbWaitingInterviews(activeUser)),
    };
};

export default compose(withRouter, withStyles({ withTheme: true }), connect(mapStateToProps, mapDispatchToProps))(App);
